import { render, staticRenderFns } from "./FcucProfile.vue?vue&type=template&id=5ca94d15&scoped=true&"
import script from "./FcucProfile.vue?vue&type=script&lang=js&"
export * from "./FcucProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca94d15",
  null
  
)

export default component.exports